export const API_BASEURL = process.env.VUE_APP_API;
export const _ = null;
